import { render, staticRenderFns } from "./DaysOffRequest.vue?vue&type=template&id=109f5b6f&scoped=true&"
import script from "./DaysOffRequest.vue?vue&type=script&lang=js&"
export * from "./DaysOffRequest.vue?vue&type=script&lang=js&"
import style0 from "./DaysOffRequest.vue?vue&type=style&index=0&id=109f5b6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109f5b6f",
  null
  
)

export default component.exports